import { EMAIL_INFO_OPTIONS } from "./EmailOptions";
import { useTranslation } from "react-i18next";
import { Card, Typography } from "antd";
import CardTitle from "components/CardTitle";
import { FaInfoCircle } from "react-icons/fa";

export default function EmailOptionsValues(): React.ReactElement {
  const { t } = useTranslation();

  return (
    <Card
      title={<CardTitle icon={<FaInfoCircle />} title={t("Email configuration keywords")} />}
      className="antd-newrai-card email-keywords-card"
    >
      <div className="email-keywords-content">
        {EMAIL_INFO_OPTIONS.map(item => {
          return (
            <div key={item.title} className="email-keywords-group">
              <Typography.Text strong className="email-keywords-group__title">
                {t(item.title)}
              </Typography.Text>
              {item.options.map(value => (
                <div key={value.key} className="email-keyword-item">
                  <Typography.Text code copyable={{ text: value.key }}>
                    {value.key}
                  </Typography.Text>
                  <Typography.Text type="secondary">{value.value}</Typography.Text>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </Card>
  );
}
